module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_1.71e7acf1.png";